import { PAGINATION_LIMIT } from '@src/constants';
import { getApiClient } from './api';

const createChatId = async (chatId) => {
  const api = getApiClient();

  try {
    const res = await api({
      method: 'POST',
      url: '/accounts/telegram/add-chat-id',
      data: { chatId },
    });

    return res;
  } catch (error) {
    return error.response?.data;
  }
};

const switchNotify = async () => {
  const api = getApiClient();

  try {
    const res = await api({
      method: 'PUT',
      url: '/accounts/telegram/toggle-notification',
    });

    return res;
  } catch (error) {
    return error.response?.data;
  }
};

const getAccounts = async ({
  limit = PAGINATION_LIMIT,
  page = 1,
  search = '',
  sort = 'createdAt_desc',
  fields,
  searchFields,
  status,
  type,
}) => {
  const api = getApiClient();
  try {
    const res = await api({
      method: 'GET',
      url: '/accounts',
      params: {
        limit,
        offset: (page - 1) * PAGINATION_LIMIT,
        search,
        fields,
        sort,
        searchFields,
        status,
        type,
      },
    });

    return res;
  } catch (error) {
    return error.response?.data;
  }
};

const createAccount = async ({
  username,
  password,
  facilityId,
  roles,
  permissions,
}) => {
  const api = getApiClient();
  try {
    const res = await api({
      method: 'POST',
      url: '/accounts',
      data: {
        username,
        password,
        facilityId,
        roles,
        permissions,
      },
    });

    return res;
  } catch (error) {
    return error.response?.data;
  }
};

const updateAccount = async ({
  accountId,
  username,
  facilityId,
  roles,
  permissions,
}) => {
  const api = getApiClient();
  try {
    const res = await api({
      method: 'PUT',
      url: `/accounts/${accountId}`,
      data: {
        username,
        facilityId,
        roles,
        permissions,
      },
    });

    return res;
  } catch (error) {
    return error.response?.data;
  }
};

const deleteAccount = async (deletingAccountId) => {
  const api = getApiClient();
  try {
    const res = await api({
      method: 'DELETE',
      url: `/accounts/${deletingAccountId}`,
    });

    return res;
  } catch (error) {
    return error.response?.data;
  }
};

export {
  createChatId,
  switchNotify,
  getAccounts,
  createAccount,
  updateAccount,
  deleteAccount,
};
